/** @jsx jsx */
import { jsx, Text, Flex, Box } from 'theme-ui';
import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { Button } from '@themed';
import { CountryCalculationType } from '@types';
import { ImageLoader, ListItemProps } from '@core';
import { ALL_COUNTRIES, useTranslate } from '@modules';
import { commonStyles, countryCalculationListItemStyles, countryListItemStyles, institutionListItemStyles } from './List.styles';

export const CountryListItem = ({
  text, icon, onSelect, id, className, selected,
}: ListItemProps) => <Button
  className={className}
  variant="buttons.pure"
  sx={countryListItemStyles.box(selected)}
  onClick={() => onSelect && id && onSelect(id)}
>
  {icon ? <ImageLoader src={icon.url} alt={icon.alternativeText} sx={commonStyles.icon} />: <Box sx={commonStyles.icon} />}
  <Flex sx={countryListItemStyles.textWithSelection}>
    <Text variant="fsText">{text}</Text>
    {selected && <FiCheck style={commonStyles.tick} />}
  </Flex>
</Button>;

export const CountryCalculationListItem = ({
  text, icon, onSelect, id, title, selected, className,
}: ListItemProps) => {
  const isAllCountriesAverage = id === `${ALL_COUNTRIES}.${CountryCalculationType.Average}`;
  const isAllCountriesBest = id === `${ALL_COUNTRIES}.${CountryCalculationType.Best}`;
  const isAllCountries = isAllCountriesAverage || isAllCountriesBest;
  const __ = useTranslate();
  const allCountriesAverageText = __('common.allCountriesAverage');
  const allCountriesBestText = __('common.allCountriesBest');

  if (isAllCountries) {
    return <Button
      className={className}
      variant="buttons.pure"
      sx={countryCalculationListItemStyles.box(selected)}
      onClick={() => onSelect && id && onSelect(id)}
    >
      <Flex sx={countryCalculationListItemStyles.allTitleArea}>
        {icon && <ImageLoader src={icon.url} alt={icon.alternativeText} sx={commonStyles.icon} /> }
      </Flex>
      <Flex sx={countryCalculationListItemStyles.textArea}>
        {isAllCountriesAverage && <Text variant="fsText">{allCountriesAverageText}</Text>}
        {isAllCountriesBest && <Text variant="fsText">{allCountriesBestText}</Text>}
        {selected && <FiCheck style={commonStyles.tick} />}
      </Flex>
    </Button>;
  }

  return <Button
    data-testid={id}
    className={className}
    variant="buttons.pure"
    sx={countryCalculationListItemStyles.box(selected)}
    onClick={() => onSelect && id && onSelect(id)}
  >
    <Flex sx={countryCalculationListItemStyles.titleArea}>
      {icon && title && <React.Fragment>
        <ImageLoader src={icon.url} alt={icon.alternativeText} sx={commonStyles.icon} />
        <Text variant="fsText" sx={countryCalculationListItemStyles.title}>{title}</Text>
      </React.Fragment>}
    </Flex>
    <Flex sx={countryCalculationListItemStyles.textArea}>
      <Text variant="fsText">{text}</Text>
      {selected && <FiCheck style={commonStyles.tick} />}
    </Flex>
  </Button>;
};

export const InstitutionListItem = ({
  text, onSelect, id, selected, className,
}: ListItemProps) => <Button
  data-cy={text}
  className={className}
  variant="buttons.pure"
  sx={institutionListItemStyles.item(selected)}
  onClick={() => onSelect && id && onSelect(id)}
>
  {selected && <FiCheck style={institutionListItemStyles.tick} />}
  {text && <Text>{text}</Text>}
</Button>;
